export default __webpack_public_path__ + "static/media/miguel-lopes-16.d96291d6.jpg";